// extracted by mini-css-extract-plugin
module.exports = {"Products":"Products_Products__1BHNa","overflow":"Products_overflow__3NW4z","skeletonTitle":"Products_skeletonTitle__1fJZ9","skeletonShimmer":"Products_skeletonShimmer__1Zvnv"};